import React from "react";
import { Container } from "react-bootstrap";
import "./event.scss";
// import qr from "../../images/qr-pfbjj.jpg";
import PacificOpen from "./PacificOpen";
import PastTourn from "./PastTourn";
import WomensDefense from "./WomensDefense";
import { Helmet } from "react-helmet";

function Event() {
  return (
    <>
      <Helmet>
        <title>Pacific Federation of Brazilian Jiu Jitsu | Events</title>
      </Helmet>
      <div className="section-padding event-sec">
        <Container>
          <h2 className="text-center">Upcoming Events</h2>
          <h3 className="mb-5 text-center">Coming soon...</h3>
          <h2 className="text-center mt-5">Previous Events</h2>
          <PacificOpen />
          <PastTourn />
          <WomensDefense />
        </Container>
      </div>
    </>
  );
}

export default Event;
